<script>
/* eslint-disable */
    import ProfesionalService from '@/api/ProfesionalService';
    const profesionalService = new ProfesionalService();

    export default {
        name: 'DiagnosticoOptions',
        props: {
            obligatorio: {
                type: Array,  
                required: true
            },
            idProfesional: {
                type: Number,  
                required: true
            },
            modelValue: {
                type: [String, Number],
                required: false,
                default: null
            }
        },
        data: () => ({
            especialidades: [],
            cargando: false
        }),
        async mounted() {
            await this.getEspecialidadesProfesional(this.idProfesional);
        },
        methods: {
            onEspecialidadChange(newValue) {
                this.$emit('especialidadSeleccionada', newValue);
            },
            async getEspecialidadesProfesional(idProfesional) {
                if(!idProfesional){
                    this.especialidades = [];
                    return;
                }
                this.cargando = true;
                const response = await profesionalService.getEspecialidadesProfesional(idProfesional);
                if(response.status === 200) {
                    this.especialidades = response.data;
                }
                this.cargando = false;
            }
        }
    }
</script>

<style src="../assets/general.css"></style>

<template>
     <v-row>
        <v-col cols="12" md="5">
            <h4 class="my-text-black">Especialidad del profesional efector</h4>
        </v-col>
        <v-col cols="12" md="7">
            <p text-h5 class="font-weight-light">Busque por nombre</p>
        </v-col>
    </v-row>
    <v-autocomplete
        :rules="obligatorio"
        label="Especialidad"
        :items="especialidades"
        return-object
        item-title="nombre"
        variant="solo"
        @update:modelValue="onEspecialidadChange"
        auto-select-first="true"
        no-data-text="No ha seleccionado un profesional o este no tiene especialidades"
        :menu-props="{width: 250}"
        min-width="250"
        ref="autocomplete"
        class="asterisco"
        :loading="cargando"
    >
    </v-autocomplete>
</template>